






import { Component, Vue, Inject } from "vue-property-decorator";
import { payResult, getUserQrcode } from "@/req/pay";
import QRCode from "qrcodejs2";
@Component
export default class Home extends Vue {
  @Inject() public readonly switchOver;
  public status = false;
  public payQrcodeBox = "";
  public timerIdEnd: any = 0;
  public async show(obj) {
    this.status = true;
    const orderNo = obj.order_no;
    const res = await getUserQrcode({
      order_no: orderNo,
      type: 1,
    });
    if (res.code === 200) {
      this.$nextTick(() => {
        this.payQrcodeBox = new QRCode("payQrcode", {
          width: 150,
          height: 150,
          text: res.data.url,
        });
      });
      this.handleQrcodeCheck(orderNo);
    }
  }
  public async handleQrcodeCheck(orderNo) {
    const timer = await new Promise((resovle) => {
      const timerId = setTimeout(async () => {
        try {
          const res = await payResult({
            order_no: orderNo,
          });
          this.clearTimer();
          if (res.code === 200 && res.data.status === "success") {
            this.switchOver(false);
            this.$toast(res.msg);
          } else if (res.code === 200) {
            this.handleQrcodeCheck(orderNo);
          } else {
            this.switchOver(false);
          }
        } catch (err) {
          this.handleQrcodeCheck(orderNo);
        }
      }, 5000);
      resovle(timerId);
    });
    this.timerIdEnd = timer;
  }
  public clearTimer() {
    const end = this.timerIdEnd;
    const start = end - 100 > 0 ? end - 100 : 0;
    for (let i = start; i <= end; i++) {
      clearTimeout(i);
    }
  }
  public beforeDestroy() {
    this.clearTimer();
  }
}
